import React, { useEffect } from "react";
import { Popup, Position, ToolbarItem } from "devextreme-react/popup";
import InvoicePaymentGrid from "../vendorReports/InvoicePaymentGrid";
import { useDispatch } from "react-redux";
import { getResourceAPI } from "../../redux/slices/resourceSlice";

const PaymentsModal = ({ visible, handleCancel, id, trade_case_id }) => {
  const dispatch = useDispatch();

  useEffect(() => {
    if (id)
      dispatch(
        getResourceAPI({ path: "invoice-payments", query: { invoice_id: id } })
      );
  }, [dispatch, id]);
  return (
    <Popup
      visible={!!visible}
      closeOnOutsideClick={false}
      showCloseButton={false}
      showTitle={true}
      title="Manage payments"
      container=".dx-viewport"
    >
      <InvoicePaymentGrid resourceName="invoice-payments" id={id} tradeCaseId={trade_case_id}  />
      <Position at="center" my="center" />
      <ToolbarItem
        widget="dxButton"
        toolbar="bottom"
        location="after"
        options={{
          icon: "close",
          text: "Close",
          onClick: handleCancel,
        }}
      />
    </Popup>
  );
};

export default PaymentsModal;
